// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Notifications from 'vue-notification'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import InfiniteLoading from 'vue-infinite-loading'
import VeeValidate from 'vee-validate'
import * as filters from './filters'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'
import VueLetterAvatar from 'vue-letter-avatar'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = process.env.API_BASE_URL

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  notFoundRedirect: {name: 'NotFound'},
  refreshData: {
    enabled: false
  }
})

Vue.use(Notifications)
Vue.use(InfiniteLoading)
Vue.use(VeeValidate)
Vue.use(ElementUI, { locale })
Vue.use(Loading)
Vue.use(VueLetterAvatar)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js